export function getTokenHeaders() {
    let user = localStorage.getItem('access_token');
    if (user) {
        return {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + user,
            }
        };
    } else {
        return {};
    }
}

export function getDefaultHeaders() {
    return {
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        }
    };
}


// WEBPACK FOOTER //
// ./src/SHARED/helpers/api.helper.js